const supportPage = `plus_supportpage(uid: "blt58546db52e4fe932") {
    customer_relations_team {
        title
        text
    }
    faqs {
        title
        item {
            title
            text
        }
    }
}`;

export default supportPage;
